var React = require('react');

function BackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 9.5L5.5575 8.4425L2.1225 5L5.5575 1.5575L4.5 0.5L-4.37497e-06 5L4.5 9.5Z","fill":"#7C8389"}));
}

BackInline.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = BackInline;

BackInline.default = BackInline;
